import React from 'react';
import countingStepsImage from '../../../public/static/images/rat-race/counting-steps.png';
import appStoreBadge from '../../../public/static/images/rat-race/app-store.png';
import styles from './index.module.scss';

const getAssetSrc = (asset) => asset?.src || asset;

export default function RatRaceHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.heroInner}>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>
            Stop counting steps.
            <br />
            Start looking forward to them.
          </h1>
          <p className={styles.descriptionText}>
            A feel-good step-counting app that rewards steps with screen time
            alongside your own little rat sidekick.
            <br />
            <br />
            Pick a step goal that fits your life a lap around the block or a new
            personal best.
            <br />
            <br />
            Start your streak today.
          </p>
        </div>
        <img
          className={styles.heroCountingSteps}
          src={getAssetSrc(countingStepsImage)}
          alt="Rat Race step progress with social apps to unlock"
        />
        <div className={styles.ctaContainer}>
          <button type="button" className={styles.heroDownloadButton}>
            Download The App
          </button>
          <button type="button" className={styles.appStoreButton}>
            <img
              className={styles.appStoreBadge}
              src={getAssetSrc(appStoreBadge)}
              alt="Download on the App Store"
            />
          </button>
        </div>
      </div>
    </section>
  );
}
